<template>
<div>
  <div class="content-wrapper">
    <div class="content">
      <div class="header">
        <div class="title">¿Cómo te podemos <span>ayudar</span>?</div>
        <BaseInput class="search" type="text" placeholder="Escribe lo que estas buscando" v-model="search" />
      </div>
      <div class="cards" v-if="search === '' && section === 0">
        <div class="card" @click="section = 1">
          <img class="card-img" src="/help/info.svg" height="80" width="80">
          <div class="card-title">Información General</div>
          <div class="card-description">Encuentra respuestas a las preguntas más frecuentes</div>
        </div>
        <div class="card" @click="section = 2">
          <img class="card-img" src="/help/investors.svg" height="80" width="80">
          <div class="card-title">Inversionistas</div>
          <div class="card-description">Descubre como invertir en nuestros proyectos</div>
        </div>
        <div class="card" @click="section = 3">
          <img class="card-img" src="/help/restaurants.svg" height="80" width="80">
          <div class="card-title">Restaurantes</div>
          <div class="card-description">Descubre cuáles son los requisitos para que tu restaurante consiga inversión por medio de Flagship</div>
        </div>
        <div class="card" @click="section = 4">
          <img class="card-img" src="/help/money.svg" height="80" width="80">
          <div class="card-title">Retornos de Inversión</div>
          <div class="card-description">Aprende a ligar tu cuenta de banco para recibir tu dinero de vuelta</div>
        </div>
        <div class="card" @click="section = 5">
          <img class="card-img" src="/help/account.svg" height="80" width="80">
          <div class="card-title">Mi Cuenta</div>
          <div class="card-description">Modifica y personaliza tu perfil de Flagship</div>
        </div>
      </div>
      <div v-else>
        <div><div class="topic-title" style="cursor: pointer;" @click="section = 0; search = '';">← Regresar</div></div>
        <div v-for="(topic, index) in filteredSearch" :key="index" class="topic">
          <div class="topic-title">{{ topic.title }}</div>
          <div class="topic-content" v-html="topic.content"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BaseInput from '@/components/base/BaseInput.vue';

const { mapState, mapActions } = createNamespacedHelpers('support');
export default {
  name: 'HelloWorld',
  data() {
    return {
      search: '',
      section: 0,
    };
  },
  props: {
    msg: String,
  },
  computed: {
    filteredSearch() {
      const searchVal = this.search;
      if (this.search !== '') {
        return this.questions.filter(item => item.title.toLowerCase().includes(searchVal.toLowerCase()));
      } else if (this.section !== 0) {
        const sectionQuestions = this.questions.filter(question => question.section === this.section);
        if (!sectionQuestions) {
          return [];
        }
        return this.createList(sectionQuestions);
      }
      return [];
    },
    ...mapState([
      'questions',
    ]),
  },
  methods: {
    getLastElement(questionsArray) {
      for (let i = 0; i < questionsArray.length; i += 1) {
        const element = questionsArray[i];
        if (!element.nextId) {
          return element;
        }
      }
      return null;
    },
    getPreviousElement(questionsArray, id) {
      for (let i = 0; i < questionsArray.length; i += 1) {
        const element = questionsArray[i];
        if (element.nextId === id) {
          return element;
        }
      }
      return null;
    },
    createList(questionsArray) {
      const helpArray = [];
      let currentElement = this.getLastElement(questionsArray);
      while (currentElement !== null) {
        helpArray.unshift(currentElement);
        currentElement = this.getPreviousElement(questionsArray, currentElement.id);
      }
      return helpArray;
    },
    ...mapActions([
      'getQuestions',
    ]),
  },
  components: {
    BaseInput,
  },
  async mounted() {
    if (this.$route.query.section) {
      this.section = parseInt(this.$route.query.section, 10);
    }
    await this.getQuestions();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content-wrapper {
  height: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  padding-top: 50px;
  font-family: 'Inter', sans-serif;
}
.content {
  width: 1200px;
  display: flex;
  padding: 90px 38px;
  flex-direction: column;
  border-radius: 6px;
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: baseline;
}
.title {
  font-weight: bolder;
  font-size: 38px;
  margin-bottom: 20px;
  span {
    color: #3479e9;;
  }
}
.search {
  width: 400px !important;
  font-size: 17px !important;
}
.cards {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.card {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 30%;
  align-items: center;
  margin: 20px 0;
  padding: 50px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  cursor: pointer;
  background-color: white;
}
.card-title {
  font-weight: bolder;
  font-size: 24px;
  margin-bottom: 20px;
}
.card-img {
  margin-bottom: 45px;
  width: 80%;
}
.card-description {
  font-size: 16px;
  text-align: center;
  line-height: 20px;
}
.topic {
  margin: 30px 0;
}
.topic-title {
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 14px;
}
.topic-content {
  line-height: 22px;
  /deep/ h1 {
    color: #2c70c1;
    margin-top: 12px;
  }
  /deep/ ol {
    margin: 8px 0;
  }
  /deep/ a {
    color: #2c70c1;
  }
}
@media only screen and (max-width: 1200px) {
  .content {
    width: 100%;
  }
  .card {
    width: 45%;
  }
}
@media only screen and (max-width: 720px) {
  .content {
    width: 100%;
  }
  .card {
    width: 90%;
  }
}
@media only screen and (max-width: 450px) {
  .content {
    width: 100%;
  }
  .card {
    width: 90%;
  }
}
</style>
